import React from "react";
import FadeInSection from "./FadeInSection";
import SectionHeading from "./SectionHeading";

const TECH_STACK = [
    "Java",
    "Spring Boot",
    "MERN",
    "RabbitMQ",
    "PostgreSQL",
    "SQL",
];

const About = () => (
    <section id="about" className="section">
        <div className="shell">
            <FadeInSection>
                <SectionHeading index="01" title="about me" />
            </FadeInSection>

            <div className="grid gap-10 md:grid-cols-[1.5fr,1fr] md:items-start md:gap-16">
                <FadeInSection>
                    <div className="max-w-prose space-y-5 text-[16px] leading-relaxed text-ink-dim sm:text-[17px]">
                        <p>
                            I'm a{" "}
                            <span className="font-medium text-ink">
                                Software Engineering undergraduate
                            </span>{" "}
                            at{" "}
                            <a
                                href="https://www.sliit.lk/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                SLIIT
                            </a>
                            , currently working as an Associate Software
                            Engineer with a focus on Java and Spring Boot.
                        </p>
                        <p>
                            Outside of work I follow developments in science,
                            play video games, and write the occasional blog
                            post.
                        </p>
                    </div>

                    <p className="eyebrow mt-8 mb-4 block sm:mt-10">Working with</p>
                    <ul className="flex flex-wrap gap-2">
                        {TECH_STACK.map((tech, i) => (
                            <li key={tech}>
                                <FadeInSection delay={`${i * 60}ms`}>
                                    <span
                                        className="block rounded-full border border-line bg-surface px-3.5 py-1.5
                                                   font-mono text-[11px] tracking-[0.06em] text-ink-dim
                                                   transition-colors duration-300 hover:border-accent/40 hover:text-accent"
                                    >
                                        {tech}
                                    </span>
                                </FadeInSection>
                            </li>
                        ))}
                    </ul>
                </FadeInSection>

                <FadeInSection delay="120ms">
                    <div className="group relative mx-auto w-full max-w-[280px] md:mx-0">
                        <span
                            aria-hidden="true"
                            className="absolute inset-0 translate-x-3 translate-y-3 rounded-card
                                       border border-accent/40 transition-transform duration-500
                                       ease-soft group-hover:translate-x-2 group-hover:translate-y-2"
                        />
                        {/* Full colour on touch — there's no hover there, so a
                            grayscale default would just never resolve. */}
                        <img
                            src="/assets/me_prof.jpg"
                            alt="Gayashan Hansaja"
                            className="relative w-full rounded-card object-cover
                                       transition-all duration-500 ease-soft
                                       md:grayscale md:group-hover:grayscale-0"
                        />
                    </div>
                </FadeInSection>
            </div>
        </div>
    </section>
);

export default About;
